import type { SupabaseClient } from '../../lib/supabase';

export interface ProspectingAvailability {
  reader_enabled: boolean;
  message_enabled: boolean;
  operations_enabled: boolean;
}

export const INACTIVE_PROSPECTING: Readonly<ProspectingAvailability> = Object.freeze({
  reader_enabled: false,
  message_enabled: false,
  operations_enabled: false,
});

/** Only explicit booleans enable a feature. No private response fields escape. */
export function decodeAvailability(value: unknown): ProspectingAvailability {
  if (value === null || typeof value !== 'object' || Array.isArray(value))
    return INACTIVE_PROSPECTING;
  const row = value as Record<string, unknown>;
  return {
    reader_enabled: row.reader_enabled === true,
    message_enabled: row.message_enabled === true,
    operations_enabled: row.operations_enabled === true,
  };
}

/** Missing/unreachable discovery withholds new flows, never enables them.
 * Existing writers remain subject to their database guards. A failed new write
 * must never retry through a legacy writer, regardless of this UI snapshot. */
export async function readProspectingAvailability(client: SupabaseClient, token?: string) {
  try {
    const { data, error } = await client.rpc(
      'read_prospecting_availability',
      token === undefined ? {} : { p_token: token },
    );
    return error ? INACTIVE_PROSPECTING : decodeAvailability(data);
  } catch {
    return INACTIVE_PROSPECTING;
  }
}
